import eventsModule from '@events/module/store/type'
import chatModule from '@chat/module/store/type'

import {mapGetters, mapActions, mapState} from 'vuex';

export default {
    methods: {
        ...mapActions({
            reloadEvent: eventsModule.actions.events.loadInfo,
            toggleEventLike: eventsModule.actions.events.like,
            setBang: eventsModule.actions.setBang,
            requestMembership: eventsModule.actions.membership.request,
            showDialog: 'showDialog'
        }),
        updateMembership(payload){
            if(this.showJoinModalIfNeed()){
                return false;
            }
            let membershipStatus = this.bang.membership || null 
            console.log('[updateMembership]', {
                initialStatus: membershipStatus
            })

            let self = this
            switch (membershipStatus) {
                case null:
                case 'leaved':{
                    // Dialog - I want to take part. Send my application - YES / NO
                    // Your application has been sent
                    payload.action = 'request'
                    this.showDialog({
                        mode: 'confirm',
                        message: 'Send your application?',
                        callback: async () => {
                            await self.requestMembership(payload)
                            self.reloadEvent({eventId: payload.eventId, edit : 0, dont_reset_members : true})
                            /*self.reset();
                            if (self.$refs.infiniteLoadingBangMembers) {
                                self.$refs.infiniteLoadingBangMembers.stateChanger.reset();
                            }*/
                        }
                    })

                    break
                }
                case 'host':{
                    // You are the host
                    return
                }
                case 'member':{
                    // I am a member already - LEAVE / STAY
                    // Dialog - Leave now? - NO / YES
                    // You have left this event
                    this.showDialog({
                        mode: 'confirm',
                        message: `Leave this bang?`,
                        callback: () => {
                            payload.action = 'leave'
                            self.requestMembership(payload)

                            this.closeBang();
                            setTimeout(function(){
                                app.$emit('reload-events')
                            }, 1500)
                        }
                    })
                    break
                }
                case 'requested':{
                    // Your application has been sent already
                    return
                }
                default:{
                    console.log('[updateMembership] Out of scope. Aborted.')
                    return
                }
            }
        },
        updateUserMembership(user, action) {
            let self = this
            let payload = {
                eventId: this.eventIdComputed,
                userId: user.id,
                action
            }

            if (action === 'accept') {
                this.showDialog({
                    mode: 'confirm-or-view-profile',
                    user:  user,
                    message: `Accept ${user.headline} to the bang?`,
                    callback: async () => {
                        await self.requestMembership(payload)
                        self.reset();
                        if (self.$refs.infiniteLoadingBangMembers) {
                            self.$refs.infiniteLoadingBangMembers.stateChanger.reset();
                        }
                    },
                    callbackNegative: async () => {
                        payload.action = 'reject'
                        await self.requestMembership(payload)
                        self.reset();
                        if (self.$refs.infiniteLoadingBangMembers) {
                            self.$refs.infiniteLoadingBangMembers.stateChanger.reset();
                        }
                    },
                })

            } else if (action === 'remove') {
                this.showDialog({
                    mode: 'confirm',
                    message: `Remove ${user.name} from the bang?`,
                    callback: async () => {
                        await self.requestMembership(payload)
                        self.reset();
                        if (self.$refs.infiniteLoadingBangMembers) {
                            self.$refs.infiniteLoadingBangMembers.stateChanger.reset();
                        }
                    }
                })
            }
        }
    },
    computed: {
        ...mapGetters({
            bangData: eventsModule.getters.bang,
            unreadEventMessagesCount: chatModule.getters.messages.count.unreadEvent,
        }),
        ...mapState({
        }),
        membershipActionText(){
            let string = 'join'
            if (this.bang.membership === 'host') {
                string = 'host'
            } else if (this.bang.membership === 'member') {
                string = 'member'
            } else if (this.bang.membership === 'requested') {
                string = 'pending'
            } else if (
                this.bang.membership === 'removed'
                ||
                this.bang.membership === 'rejected'
            ) {
                string = 'declined'
            } else if (this.bang.membership === null) {
                string = 'join'
            }
            return this.trans(string)
        },
        membershipActionBtnClass(){
            if (this.bang.membership === 'member') {
                return 'btn'
            }
            if (this.bang.membership === 'host') {
                return ['btn', 'bb-button-no_pointer']
            }
            return 'btn'
        },
        membershipActionDisabled(){
            return ['requested', 'rejected'].includes(this.bang.membership)
        },
    }
}
